import { get, post, urlApiTegra } from "../../../service/api"

const url = urlApiTegra

async function getFrequency(token: string){
    return get(`${url}/time-frequency`, token)
}

async function getConfig(token: string){
    return get(`${url}/config-parameters`, token)
}

async function postSave(data: object ,token: string) {
    return post(`${url}/config-parameters`, data, token)
}

export {
    getFrequency,
    getConfig,
    postSave
}